var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128058(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4,.cls-5{fill:#fff;}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#6e6e6e;stroke-width:1.25px;}.cls-2,.cls-3,.cls-5{stroke-linecap:round;}.cls-2,.cls-5{stroke-linejoin:round;}.cls-3,.cls-4{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.38,96.79c-4-5-6.46-13.48-6.46-28.12,0-28.6.1-57,31.5-57s31.49,28.44,31.49,57c0,14.58-2.39,23.09-6.4,28.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.66,83.34l-15,6.47c-6.39,2.76-10.43,8.47-10.43,14.71v8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.17,83.34l15,6.47c6.39,2.76,10.44,8.47,10.44,14.71v8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.92,76v8.08c0,5,3.94,7.24,7.5,7.24s7.5-2.23,7.5-7.24V76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83,58.9c3.06.44,4-2,4.94-4.94,1.08-3.62-.27-5.7-3.33-6.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.88,58.9c-3.06.44-4.05-2-4.93-4.94-1.09-3.62.26-5.7,3.32-6.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.5,42.29c0-.28,0-.56,0-.83-1.76-2.3-3.82-6.75-6.43-13.19,0,0-12.19,13.43-39.72,14.94.09,15.45,2.48,22,6.71,27.35s11.43,9.59,16.37,9.59S74.23,76,78.09,70.55,84.5,56.09,84.5,42.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.66,52.54l-1,6.82a2.18,2.18,0,0,0,2.16,2.52h1.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.88,66.33c0,1.79-2.16,3.59-4.46,3.59S57,68.12,57,66.33Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.31,
    y1: 45.93,
    x2: 72.29,
    y2: 45.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.52,
    y1: 45.96,
    x2: 50.54,
    y2: 45.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,54a3.08,3.08,0,0,1,5.88,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46,54a3.08,3.08,0,0,1,5.88,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128058);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_058.026f5a7f1a22f6e0e79ffb5a4fca50d6.svg";
export { ForwardRef as ReactComponent };